import cx from 'clsx';
import React from 'react';

import { ReactComponent as AngelConnectorIcon } from '@assets/svg/sensors-temperature/angle_connector.svg';
import { ReactComponent as EquipmentIcon } from '@assets/svg/sensors-temperature/equipment_D111.svg';
import { ReactComponent as IndicatorIcon } from '@assets/svg/sensors-temperature/indicator.svg';
import { ReactComponent as StraightConnectorIcon } from '@assets/svg/sensors-temperature/straight_connector.svg';
import { ReactComponent as UnitIcon } from '@assets/svg/sensors-temperature/unit.svg';

import style from './style.module.scss';

interface IProps {
  userMetric: string;
}

const SecondRow: React.FC<IProps> = ({ userMetric }) => {
  return (
    <div className={style.row}>
      <div className={style.cell}>
        <AngelConnectorIcon className={style.rightAngelConnectorIcon} />
        <div className={style.bathTempContainer}>
          <div className={style.bathText}>
            <span>MF6 Bath Temp</span> <span>MF6 Roof Temp</span>
          </div>
          <div className={style.bathIcon}>
            <span>MF6</span>
            <UnitIcon />
          </div>
        </div>
      </div>
      <div className={style.cell}>
        <StraightConnectorIcon className={style.straightConnectorIcon} />
        {/* placeholder container */}
        <div className={cx(style.sensorsEquipmentItemContainer, style.additionalTopPadding, style.hidden)}>
          <div className={style.equipmentIconContainer}>
            <EquipmentIcon />
          </div>
          <div className={style.temperature}>
            0.00 {userMetric}
            <IndicatorIcon className={style.indicatorIcon} />
          </div>
        </div>
        <div className={cx(style.sensorsEquipmentItemContainer, style.additionalTopPadding)}>
          <span className={style.name}>D-121</span>
          <div className={style.equipmentIconContainer}>
            <EquipmentIcon />
          </div>
          <div className={style.temperature}>
            0.00 {userMetric}
            <IndicatorIcon className={style.indicatorIcon} />
          </div>
        </div>
      </div>
      <div className={style.cell}>
        <StraightConnectorIcon className={style.straightConnectorIcon} />
        <div className={cx(style.sensorsEquipmentItemContainer, style.additionalTopPadding)}>
          <span className={style.name}>D-122</span>
          <div className={style.equipmentIconContainer}>
            <EquipmentIcon />
          </div>
          <div className={style.temperature}>
            0.00 {userMetric}
            <IndicatorIcon className={style.indicatorIcon} />
          </div>
        </div>
        <div className={cx(style.sensorsEquipmentItemContainer, style.additionalTopPadding)}>
          <span className={style.name}>D-123</span>
          <div className={style.equipmentIconContainer}>
            <EquipmentIcon />
          </div>
          <div className={style.temperature}>
            0.00 {userMetric}
            <IndicatorIcon className={style.indicatorIcon} />
          </div>
        </div>
      </div>
      <div className={style.cell}>
        <StraightConnectorIcon className={style.straightConnectorIcon} />
        <div className={cx(style.sensorsEquipmentItemContainer, style.additionalTopPadding)}>
          <span className={style.name}>D-124</span>
          <div className={style.equipmentIconContainer}>
            <EquipmentIcon />
          </div>
          <div className={style.temperature}>
            0.00 {userMetric}
            <IndicatorIcon className={style.indicatorIcon} />
          </div>
        </div>
        <div className={cx(style.sensorsEquipmentItemContainer, style.additionalTopPadding)}>
          <span className={style.name}>D-125</span>
          <div className={style.equipmentIconContainer}>
            <EquipmentIcon />
          </div>
          <div className={style.temperature}>
            0.00 {userMetric}
            <IndicatorIcon className={style.indicatorIcon} />
          </div>
        </div>
      </div>
      <div className={style.cell}>
        <StraightConnectorIcon className={cx(style.straightConnectorIcon, style.lastStraightConnectorIcon)} />
        <div className={cx(style.sensorsEquipmentItemContainer, style.additionalTopPadding)}>
          <span className={style.name}>D-126</span>
          <div className={style.equipmentIconContainer}>
            <EquipmentIcon />
          </div>
          <div className={style.temperature}>
            0.00 {userMetric}
            <IndicatorIcon className={style.indicatorIcon} />
          </div>
        </div>
        {/* placeholder container */}
        <div className={cx(style.sensorsEquipmentItemContainer, style.additionalTopPadding, style.hidden)}>
          <div className={style.equipmentIconContainer}>
            <EquipmentIcon />
          </div>
          <div className={style.temperature}>
            0.00 {userMetric}
            <IndicatorIcon className={style.indicatorIcon} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecondRow;
